module.exports = __webpack_public_path__ + "img/P4.2ad6d27.png";